app.controller("aiTermsController", [
    "$scope",
    function ($scope) {
        $scope.controllerName = "aiTermsController";
    }
]);